import { env } from '../../environment/env'
import { buildDestinationDatabasePath, paths } from '../../paths'

const accountToolUrl = env.ACCOUNT_TOOL_URL

export interface SidebarLink {
  icon: string
  label: string
  url?: string
  target?: string
  onClick?: () => void
  isWidget?: boolean
}

export interface SidebarSection {
  title: string
  variant?: 'default' | 'highlighted'
  links: SidebarLink[]
}

export interface KnowledgeDatabaseLinkConfig {
  icon: string
  label: string
  tenantId: string
}

export const knowledgeDatabaseLinks: KnowledgeDatabaseLinkConfig[] = [
  { icon: 'pi pi-map', label: 'Destination database', tenantId: 'GDKB' },
  { icon: 'pi pi-info-circle', label: 'General information', tenantId: 'GKDB' },
  { icon: 'pi pi-book', label: 'Manual & workflows', tenantId: 'GMAW' },
  { icon: 'pi pi-comments', label: 'Chatbot FAQ', tenantId: 'GFAQ' },
]

function buildKnowledgeDatabaseLink({ icon, label, tenantId }: KnowledgeDatabaseLinkConfig): SidebarLink {
  return env.DESTINATION_DATABASE_ENABLED
    ? { icon, label, url: buildDestinationDatabasePath(tenantId) }
    : { icon, label, url: `${accountToolUrl}/KnowledgeDataBase/${tenantId}?group=guides`, target: '_blank' }
}

export const sidebarData: SidebarSection[] = [
  {
    title: 'Go to',
    links: [
      { icon: 'pi pi-home', label: 'Dashboard', url: paths.home },
      ...env.EXCURSIONS_ENABLED ? [{ icon: 'pi pi-map', label: 'Excursions', url: paths.excursions }] : [],
      { icon: 'pi pi-calendar-clock', label: 'Visiting hours', url: paths.visitingHours },
    ],
  },
  {
    title: 'Data lists',
    links: [
      { icon: 'pi pi-list', label: 'Transfers', url: paths.transferLists },
      { icon: 'pi pi-table', label: 'Rooming', url: paths.roomingLists },
      { icon: 'pi pi-plus', label: 'Ancillaries', url: paths.ancillariesLists },
      { icon: 'pi pi-arrow-right', label: 'Inhouse', url: paths.inhouseLists },
    ],
  },
  {
    title: 'Information hub',
    links: [
      ...knowledgeDatabaseLinks.map(buildKnowledgeDatabaseLink),
      {
        icon: 'pi pi-exclamation-triangle',
        label: 'Emergency plan',
        url: 'https://sundio.sharepoint.com/sites/SunwebGroupIntranet/SiteAssets/Forms/AllItems.aspx?id=%2Fsites%2FSunwebGroupIntranet%2FSiteAssets%2FSitePages%2Fg0v1pdz8%2FCustomer%2DEmergency%2DSetup%2DSharepoint%2Epdf&parent=%2Fsites%2FSunwebGroupIntranet%2FSiteAssets%2FSitePages%2Fg0v1pdz8&isSPOFile=1&xsdata=MDV8MDJ8fDhmNWY5NjlmMmFlMzRmYmZjMjhkMDhkZDZkNDAyOGMzfDdiNDkxNmI1ODcyODRlZWFhZDlhZGRjZDhlMDZjYjFjfDB8MHw2Mzg3ODY4NDQ0ODU3MzA5NTd8VW5rbm93bnxWR1ZoYlhOVFpXTjFjbWwwZVZObGNuWnBZMlY4ZXlKV0lqb2lNQzR3TGpBd01EQWlMQ0pRSWpvaVYybHVNeklpTENKQlRpSTZJazkwYUdWeUlpd2lWMVFpT2pFeGZRPT18MXxMMk5vWVhSekx6RTVPbU15TkRWa01XSmlMVGd4TVdVdE5HSXpZeTFoTjJGakxXUTJOVEV6TTJSbU1UTmtNMTlqWlRJNFltWTFaQzB5WWpnM0xUUTBNREF0WVdJMk9DMDFZelF6TWpKbFpHUmtNVEZBZFc1eExtZGliQzV6Y0dGalpYTXZiV1Z6YzJGblpYTXZNVGMwTXpBNE56WTBOelUzTVE9PXw2ZGYyMzI4MTZkZmY0MWUwYzI4ZDA4ZGQ2ZDQwMjhjM3xlYWIyODgzZjA2ZjA0NDM2OWRmMzdjZWQ4NjM2ZGVkZg%3D%3D&sdata=bjJLaGtaTkVibEtRaHdPVVdDSVlxQnE3WE1tYThjY1lxbklhMFlpVkRNWT0%3D&ovuser=7b4916b5%2D8728%2D4eea%2Dad9a%2Dddcd8e06cb1c%2CRoger%2EAntonell%40sunwebgroup%2Ecom&OR=Teams%2DHL&CT=1743093450069&clickparams=eyJBcHBOYW1lIjoiVGVhbXMtRGVza3RvcCIsIkFwcFZlcnNpb24iOiI1MC8yNTAzMDIwMTAxMCIsIkhhc0ZlZGVyYXRlZFVzZXIiOmZhbHNlfQ%3D%3D&SafelinksUrl=https%3A%2F%2Fsundio%2Esharepoint%2Ecom%2Fsites%2FSunwebGroupIntranet%2FSiteAssets%2FForms%2FAllItems%2Easpx',
        target: '_blank',
      },
      {
        icon: 'pi pi-clone',
        label: 'Templates & Forms',
        url: 'https://sundio.sharepoint.com/sites/DestinationServices/Shared%20Documents/Forms/AllItems.aspx?id=%2Fsites%2FDestinationServices%2FShared%20Documents%2FTemplates%20and%20Forms&p=true&ga=1&LOF=1',
        target: '_blank',
      },
      {
        icon: 'pi pi-sun',
        label: 'Sun Operations',
        url: 'https://sundio.sharepoint.com/:f:/s/DestinationServices/En3S2Ea7r2NCta0IjjPdjmcB6_WG3z-MkfHdlmlaL5CKSg?e=OmutoJ',
        target: '_blank',
      },
      {
        icon: 'pi pi-asterisk',
        label: 'Ski Operations',
        url: 'https://sundio.sharepoint.com/:f:/s/DestinationServices/Ev-v1BBJUW9IpxSfuT3CgZwBoWrx6tkRdJ5OTPdg8xuzvQ?e=Fk13wI',
        target: '_blank',
      },
      {
        icon: 'pi-clipboard',
        label: 'Season handover reports',
        url: 'https://sundio.sharepoint.com/:f:/r/sites/DestinationServices/Shared%20Documents/Season%20Handover%20Reports?csf=1&web=1&e=jBLzEq',
        target: '_blank',
      },
      {
        icon: 'pi-pencil',
        label: 'Hotel & website check',
        url: 'https://forms.office.com/Pages/ResponsePage.aspx?id=tRZJeyiH6k6tmt3NjgbLHCB2Cp3QB1hOlB5dOy9M1fFUQ05HNzBVN1lXVVhTRE5PSFJDNThaTE1LSSQlQCN0PWcu',
        target: '_blank',
      },
      {
        icon: 'pi-eye',
        label: 'Hotel & website tracker',
        url: 'https://sundio.sharepoint.com/:x:/r/sites/DestinationServices/Shared%20Documents/Content%20feedback%20form%20Sunweb%20Group.xlsx',
        target: '_blank',
      },
    ],
  },
  {
    title: 'Quick links',
    variant: 'highlighted',
    links: [
      {
        icon: 'pi pi-arrow-up-right',
        label: 'Flight tool',
        url: 'https://flightinfo.sundiogroup.com/login.aspx?ReturnUrl=%2fFlightinformation.aspx',
        target: '_blank',
      },
      {
        icon: 'pi pi-arrow-up-right',
        label: 'My account tool',
        url: accountToolUrl,
        target: '_blank',
      },
      {
        icon: 'pi pi-arrow-up-right',
        label: 'Complaint bot',
        onClick: () => window?.fcWidget?.open(),
        isWidget: true,
      },
      {
        icon: 'pi pi-arrow-up-right',
        label: 'Freshworks',
        url: 'https://sunweb.freshdesk.com/a/dashboard/default',
        target: '_blank',
      },
    ],
  },
]
